
export default defineNuxtRouteMiddleware(async (to, from) => {
  const config = useRuntimeConfig()
  
  try {
    const game = await $fetch(`/api/v1/games/${to.params?.game}`, {
      baseURL: config.public.apiBase,
    })

    useState(`game:${game.slug}`).value = game
  }
  catch {
    return null
  }
})